import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { SidebarIcon } from '../ui/media';
import { useLogout, useUser } from "../../hooks/useAuth"
import toast from 'react-hot-toast';

function Header({ toggleSidebar }) {
    const navigate = useNavigate();
    const dropdownRef = useRef(null);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [userData, setUserData] = useState(null);
    const logout = useLogout()
    const user = useUser()
    const { isSuccess: isUserSuccess, data: userResponse, isError: isUserError } = user
    const { REACT_APP_IMG_URL } = process.env

    const handleLogout = async () => {
        logout.mutate(null, {
            onSuccess: () => {
                navigate('/login');
                toast.success('Logged out successfully');
            },
            onError: () => {
                navigate('/login');
                toast.error('Session expired, logged out');
            }
        })
    };

    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownOpen(false);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (isUserError) {
            handleLogout()
        }
        if(isUserSuccess) {
            setUserData(userResponse?.data?.data)
        }
    }, [userResponse, isUserError])

    return (
        <header className="bg-white border-b border-gray-200 px-4 py-2 flex items-center justify-between shadow-sm z-10 max-h-14">
            <div className="flex items-center">
                <button
                    onClick={toggleSidebar}
                    className={`p-2 rounded-md text-gray-500 hover:text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 transition-all duration-300`}>
                    <img
                        alt='sideIcon'
                        className="h-6 w-6"
                        src={SidebarIcon} />
                </button>
            </div>
            <div className="flex items-center">
                <div className="relative" ref={dropdownRef}>
                    <button
                        onClick={() => setDropdownOpen(!dropdownOpen)}
                        className="flex items-center text-sm font-medium text-gray-700 hover:text-gray-800 focus:outline-none">
                        <img
                            className="h-8 w-8 rounded-full object-cover mr-2"
                            src={`${REACT_APP_IMG_URL}/${userData?.profile_pic}`}
                            alt="Profile"
                        />
                        <span className="hidden md:block">{userData?.full_name}</span>
                        <svg
                            className="ml-2 h-5 w-5 text-gray-400"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            aria-hidden="true">
                            <path
                                fillRule="evenodd"
                                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                clipRule="evenodd"
                            />
                        </svg>
                    </button>
                    {dropdownOpen && (
                        <div className="w-auto absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                            <div className="px-4 py-3">
                                <p className="text-sm">{userData?.name}</p>
                                <p className="text-sm font-medium text-gray-500 truncate">
                                    {userData?.email}
                                </p>
                            </div>
                            <hr />
                            <a
                                href="/settings/account"
                                className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                                Account
                            </a>
                            <button
                                onClick={() => handleLogout()}
                                className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                                Log Out
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </header>
    );
}
export default Header;